import React from 'react';
import CampusCandidateListing from 'src/components/newRecruiterFlow/campus/campusCandidateListing/CampusCandidateListing';

const CampusCandidatesListingPage = () => {
	return (
		<div>
			<CampusCandidateListing />
		</div>
	);
};

export default CampusCandidatesListingPage;
